e4.forms.mailchimp.submitHandler = function ( form ) {
    var jForm = jQuery( form );
    jQuery.ajax( {
        type: jForm.attr( 'method' ),
        url: jForm.find( 'input[name="MailChimp_SignUpURL"]' ).val().replace( '/post?', '/post-json?' ),
        data: jForm.serialize(),
        timeout: 5000,
        cache: false,
        dataType: 'jsonp',
        jsonp: 'c',
        context: form
    } ).always( function ( data ) {
        e4.forms.mailchimp.responseHandler( this, data );
    } );
};

/*
 jQuery.validator.addMethod( 'localizedNumber', function ( value, domElm ) {
 var regExpLocalizedNumber = new RegExp( '^-?(?:\\d+|\\d{1,3}(?:\\' + vetoryl.logbook.number.intergerSeperator + '\\d{3})+)?(?:\\' + vetoryl.logbook.number.decimalSeperator + '\\d+)?$' );
 return this.optional( domElm ) || regExpLocalizedNumber.test( value );
 }, jQuery.validator.messages.number );
 */

